import { graphql } from "@opensea/graphql"
import { currencyIdentifierFragment } from "../currencies/utils"
import { UsdPriceFragment } from "./UsdPrice.fragment"

export const NativePriceFragment = graphql(
  `
    fragment NativePrice on Price {
      ...UsdPrice
      token {
        unit
        contractAddress
        ...currencyIdentifier
      }
      native {
        symbol
        unit
        contractAddress
        ...currencyIdentifier
      }
    }
  `,
  [UsdPriceFragment, currencyIdentifierFragment],
)
